<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
    },
    methods:{
        save: function(){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;
            Request.do(this, this.data._id  ? 'PUT' : 'POST', Request.getDefaultHeader(this), this.data, `${Endpoints.parts.families.family}${this.data._id ? this.data._id : ''}`,
                (response)=>{//SUCCESS CALLBACK
                    this.$eventHub.$emit('refreshList');
                    this.flashMessage.info(
                        this.configMessage(this.$t('string.msg.config.family.title.success'), this.$t('string.msg.config.family.message.success'), 'top left', 3000),
                    {
                        mounted: this.showText(this.$t('string.msg.config.family.message.success')),
                        destroyed: this.clearText()
                    }) 
                    $('#spinner').modal('toggle');
                   
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
                    console.log(JSON.stringify(error));
            });
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout( () => this.text = '', 500);
        },
        configMessage :function(title, message, position, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: window.innerWidth /60,
                y: window.innerHeight /1.3,
                time: time,
            }
            return config
        },
        selectItem: function(item){
            this.data = JSON.parse(JSON.stringify(item));
            this.data.name = Common.camelize(this.data.name);

            if(this.data.name){
                this.data.name = Common.camelize(this.data.name);
            }

            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },
        clearForm: function(){
            this.data = {};
            this.data.status = "ACTIVE";
            this.data.type = "SERVICE";
        },
        configMessage :function(title, message, position, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: window.innerWidth /60,
                y: window.innerHeight /1.3,
                time: time,
            }
            return config
        },
    }
}
</script>
